export const captureLeadEmail = async (email, sourcePath = '', formData = {}) => {
  const normalized = String(email || '').trim().toLowerCase();
  if (!normalized || !normalized.includes('@')) return;
  try {
    const cacheKey = `rentual_lead_email_${normalized}`;
    if (sessionStorage.getItem(cacheKey)) return;
    sessionStorage.setItem(cacheKey, '1');

    await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/lead-entries`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: normalized,
        source_path: sourcePath || window.location.pathname,
        form_data: formData
      })
    });
  } catch (err) {
    // non-blocking
  }
};
